import React from 'react';

function SvgPdf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs />
      <path
        stroke="#192933"
        strokeWidth={2}
        d="M7 16v4a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H8a1 1 0 00-1 1v4"
      />
      <path
        fill="#192933"
        fillRule="evenodd"
        d="M18 7H2v10h16V7zM5 10h-.5v4h1v-1.25h.813a1.375 1.375 0 100-2.75H5zm1.313 1.75H5.5V11h.813a.375.375 0 010 .75zM8.938 10h-.5V14.063h1.593a2.031 2.031 0 100-4.063H8.937zm.5 3.063V11h.593a1.031 1.031 0 110 2.063h-.594zM12.812 10H15.5v1h-1.688v.75H15.5v1h-1.688V14h-1v-4z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default SvgPdf;
